import {useAuth} from "../hooks/useAuth";
import {axiosPublic} from "../service/axios";

export const useRefreshAccessToken = () => {
    const {setAccessToken, setAccount} = useAuth();

    const refresh = async () => {
        console.log("(useRefreshAccessToken) Inside Refresh!");
        const response = await axiosPublic.get('/auth/refresh-access-token', {
            withCredentials: true
        });

        console.log("(useRefreshAccessToken) Response: ", response);

        if (response.data.success) {
            setAccessToken(response.data.data.accessToken);
            setAccount(response.data.data.user);
        }

        return response.data.data.accessToken;
    }

    return refresh;
}
